import { isAfter, isBefore, isValid } from 'date-fns';

export const isValidDate = (date: Date | null): boolean | null => {
  if (!(date instanceof Date)) {
    return null;
  }
  return isValid(date) && isAfter(date, new Date('01/01/1899')) && isBefore(date, new Date('2100-1-1'));
};
